import { genresToGTMFormat } from '../helpers/analytics';
import { getTimestamp } from '../helpers/datetime';
import { ANALYTICS_PUSH } from '../constants/ActionTypes';

import {
	EVT_BUTTON_CLICK,
	EVT_ONBOARDING_CATEGORY,
	EVT_SESSION_START,
	EVT_SESSION_START_EVENT_NAME,
	EVT_LINK_CLICK,
	EVT_ONBOARDING_SUBMIT_GENDER,
	EVT_ACTION_SUBMIT_GENDER,
	EVT_ONBOARDING_SKIP_GENDER,
} from '../constants/EventTypes';
import { getPresentationForTier } from '../helpers/tiers';
import { NO_TIER_ANALYTICS_NAME } from '../constants/Tiers';

let isSessionStarted = false;

const dataLayerPush = (data) => {
	if (__ANALYTICS__) {
		dataLayerPushIfPresent(data);
	} else if (__DEBUG__) {
		// eslint-disable-next-line no-console
		console.log('analytics push', JSON.stringify(data));
		dataLayerPushIfPresent(data);
	}

	function dataLayerPushIfPresent(data) {
		if (__CLIENT__) {
			dataLayer && dataLayer.push(data);
		}
	}
};

export default (store) => (dispatch) => (action) => {
	handleAnalyticsAction(
		action,
		store,
		dataLayerPush,
		isSessionStarted,
		() => (isSessionStarted = true)
	);
	return dispatch(action);
};

export function handleAnalyticsAction(
	action,
	store,
	dataLayerPush,
	isSessionStarted,
	onSessionStarted
) {
	const { type, payload } = action;
	const state = store.getState();

	const analyticsPayload = {
		pageUrl: state.application.path.href,
	};

	switch (type) {
		case ANALYTICS_PUSH: {
			if ('Genre' in payload) {
				payload.Genre = genresToGTMFormat(payload.Genre);
			}
			dataLayerPush(payload);
			break;
		}

		case `${ANALYTICS_PUSH}_${EVT_SESSION_START}`: {
			if (!isSessionStarted) {
				onSessionStarted();
				const { tier, userId } = payload;
				const tierTitle = tier && getPresentationForTier(tier)?.title;
				Object.assign(analyticsPayload, {
					timestampStartSession: getTimestamp(),
					userid: userId,
					tier: tierTitle || NO_TIER_ANALYTICS_NAME,
				});
				dataLayerPush({
					...analyticsPayload,
					event: EVT_SESSION_START_EVENT_NAME,
				});
			}
			break;
		}

		case `${ANALYTICS_PUSH}_${EVT_ONBOARDING_SUBMIT_GENDER}`: {
			const analyticsData = {
				events: {
					category: EVT_ONBOARDING_CATEGORY,
					action: EVT_ACTION_SUBMIT_GENDER,
					label: payload.label,
				},
				event: EVT_BUTTON_CLICK,
			};
			dataLayerPush(analyticsData);
			break;
		}

		case `${ANALYTICS_PUSH}_${EVT_ONBOARDING_SKIP_GENDER}`: {
			const analyticsData = {
				events: {
					category: EVT_ONBOARDING_CATEGORY,
					action: EVT_LINK_CLICK,
					label: payload.label,
				},
				event: EVT_LINK_CLICK,
			};
			dataLayerPush(analyticsData);
			break;
		}

		default: {
			break;
		}
	}
}
